import { useMutation } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { BOOK_FLIGHT_AUTHORIZATION } from '../mutations';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { bookFlightAuthorization: bffResponse };
}

function toRestBody({ heldConfirmInput, authorizationInfo }) {
  return { ...heldConfirmInput, authorizationInfo };
}

export default function useBookFlightAuthorization(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useMutation(BOOK_FLIGHT_AUTHORIZATION, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables } = {}) =>
      restRequest({
        method: 'POST',
        path: '/air-api/v1/flights/book',
        body: toRestBody(variables ?? {}),
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
